module.exports = __webpack_public_path__ + "static/skaled.5a2a8c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/skaled.png
// module id = 437
// module chunks = 246384609461072